    import React, { useState } from 'react';
import toast from 'react-hot-toast';
    import { Link, useNavigate } from 'react-router-dom';

const SidebarDashboard = () => {
    const navigate = useNavigate();
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const [isOpen, setIsOpen] = useState(false);

    const handleDropdownToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleMouseLeave = () => {
        setIsOpen(false); 
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        toast.success('Logged Out');
        navigate('/');
      };

    return (
        <>
            <div className="area"></div>
            <nav className="main-menu" onMouseLeave={handleMouseLeave}>
                <ul>
                    <li>
                        <Link to="/Dashboard/home">
                            <i className="fa fa-home fa-2x"></i>
                            <span className="nav-text">Home</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/Dashboard/content/overview">
                            <i className="fa fa-dashboard fa-2x"></i>
                            <span className="nav-text">Delivery BI</span>
                        </Link>
                    </li>
                    <li className="has-subnav">
                        <Link to="/Dashboard/order-details">
                            <i className="fa fa-globe fa-2x"></i>
                            <span className="nav-text">Orders</span>
                        </Link>
                    </li>
                    <li className="has-subnav">
                        <Link to="/Dashboard/analytics">
                            <i className="fa fa-bar-chart-o fa-2x"></i>
                            <span className="nav-text">Analytics Graphs</span>
                        </Link>
                    </li>
                    {/* <li className="has-subnav">
                        <Link to="/Dashboard/checkout">
                            <i className="fa fa-bar-chart-o fa-2x"></i>
                            <span className="nav-text">Checkout </span>
                        </Link>
                    </li> */}

                    {/* Finance Dropdown */}
                    <li className="has-subnav nav-item dropdown">
                        <Link
                            className={`nav-link dropdown-toggle ${isOpen ? 'open' : ''}`}
                            role="button"
                            to="#"
                            onClick={handleDropdownToggle}
                        >
                            <i className="fa fa-edit fa-2x"></i>
                            <span className="nav-text">Finance</span>
                        </Link>
                        <ul className={`finance-dropdown dropdown-menu ${isOpen ? 'show' : ''}`}>
                            <li><Link className="dropdown-item" to="/Dashboard/sales-purchase">Sales Vs Purchase Summary</Link></li>
                            <li><Link className="dropdown-item" to="/Dashboard/purchasegrn">Purchase Vs GRN</Link></li>
                            <li><Link className="dropdown-item" to="/Dashboard/discounts">Discounts</Link></li>
                            <li><Link className="dropdown-item" to="/Dashboard/invoice-summary">Dabur Invoice Summary</Link></li>
                            <li><Link className="dropdown-item" to="/Dashboard/dabur-inventory-health">Dabur Inventory Health</Link></li>
                        </ul>
                    </li>

                    {/* Domestic Wallet */}
                    <li className="has-subnav" style={{ marginTop: isOpen ? '140px' : '0px' }}>
                        <Link to="/Dashboard/Transaction">
                            <i className="fa fa-camera-retro fa-2x"></i>
                            <span className="nav-text">Domestic Wallet</span>
                        </Link>
                    </li>
                    {userDetails?.role === "seller_admin" && (
                        <>
                            <li className="has-subnav">
                                <Link to="/Dashboard/upload-invoice">
                                    <i className="fa fa-upload fa-2x"></i>
                                    <span className="nav-text">Upload Invoice Excel</span>
                                </Link>
                            </li>
                            <li className="has-subnav">
                                <Link to="/Dashboard/update-remittance">
                                    <i className="fa fa-edit fa-2x"></i>
                                    <span className="nav-text">Update Remittance</span>
                                </Link>
                            </li>
                        </>
                    )}

                    <li>
                    <Link to="/Dashboard/report">
                                    <i className="fa fa-map-marker fa-2x"></i>
                                    <span className="nav-text">Report</span>
                                </Link>
                    </li>
                </ul>

                <ul className="logout">
                    <li>
                        <Link onClick={handleLogout} to="/">
                            <i className="fa fa-power-off fa-2x"></i>
                            <span className="nav-text">Logout</span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </>
    );
};

export default SidebarDashboard;
